<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="unionName">
        <span slot="label">
          <a-tooltip>
            {{ $t('工会名称') }}<template slot="title">{{ $t('工会名称') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.unionName" :maxLength="100" :placeholder="$t('通用.输入.请输入') + $t('工会名称')" />
      </a-form-model-item>
      <a-form-model-item prop="personCharge" :disabled="form.id">
        <span slot="label">
          <a-tooltip>
            {{ $t('负责人') }}<template slot="title">{{ $t('负责人') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.personCharge"
          :maxLength="100"
          :disabled="form.id"
          :placeholder="$t('通用.输入.请输入') + $t('负责人')"
        />
      </a-form-model-item>
      <a-form-model-item prop="contactPhone" :disabled="form.id">
        <span slot="label">
          <a-tooltip>
            {{ $t('联系电话') }}<template slot="title">{{ $t('联系电话') }}</template>
          </a-tooltip>
        </span>
        <a-input
          :disabled="form.id"
          v-model="form.contactPhone"
          :maxLength="20"
          :placeholder="$t('通用.输入.请输入') + $t('联系电话')"
        />
      </a-form-model-item>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTradeUnion, addTradeUnion, updateTradeUnion } from '@/api/trade/tradeUnion'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        unionName: null,

        personCharge: null,

        contactPhone: null,

        status: 0,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        contactPhone: [
          {
            required: true,
            message: this.$t('联系电话不可以为空！'),
            trigger: 'blur',
          },
        ],
        unionName: [
          {
            required: true,
            message: this.$t('工会名称不可以为空！'),
            trigger: 'blur',
          },
        ],
        personCharge: [
          {
            required: true,
            message: this.$t('负责人不可以为空！'),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        unionName: null,
        personCharge: null,
        contactPhone: null,
        status: 0,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTradeUnion({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateTradeUnion(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addTradeUnion(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
